import { queryOptions } from '@tanstack/react-query'
import { dashboardClient } from '@/api'

export const useWebhookLogDetailQuery = (companyId: string, gameId: string, webhookLogId?: string) =>
  queryOptions({
    enabled: !!webhookLogId, // only run if webhookLogId is provided
    queryKey: [gameId, 'webhook_log', webhookLogId],
    queryFn: () => dashboardClient.v1.getWebhookLogById(webhookLogId!, companyId, gameId).then(r => r.data),
    staleTime: Infinity,
  })
